import { render } from "./UploadRegistro.vue?vue&type=template&id=3221e29a"
import script from "./UploadRegistro.vue?vue&type=script&lang=js"
export * from "./UploadRegistro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__